export default {
  name: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  cpfCnpj: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: false
  },
  rg: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: false
  },
  cnh: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: false
  },
  address: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: false
  },
  addressNumber: {
    value: '',
    maxlength: '30',
    required: false,
    state: null,
    disabled: false
  },
  district: {
    value: '',
    maxlength: '70',
    required: false,
    state: null,
    disabled: false
  },
  complement: {
    value: '',
    maxlength: '70',
    required: false,
    state: null,
    disabled: false
  },
  zipcode: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  stateID: {
    value: null,
    options: [],
    clearOption: false,
    required: false,
    state: null,
    disabled: false
  },
  cityID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    disabled: false
  },
  phoneNumber: {
    value: '',
    maxlength: '15',
    required: false,
    state: null,
    disabled: false
  },
  cellNumber: {
    value: '',
    maxlength: '15',
    required: false,
    state: null,
    disabled: false
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null,
    disabled: false
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/person/form/person-form.js